
/**
 * Utility functions for blog-related calculations and transformations
 */

/**
 * Calculate reading time in minutes for a given text content
 * @param content HTML content of the blog post
 * @returns Estimated reading time in minutes
 */
export function calculateReadingTime(content: string): number {
  if (!content) return 0;
  
  // Strip HTML tags
  const text = content.replace(/<[^>]*>/g, '');
  
  // Calculate word count (average word length is 5 characters)
  const words = text.trim().split(/\s+/).length;
  
  // Average reading speed: 200-250 words per minute
  const readingTime = Math.ceil(words / 225);
  
  // Return at least 1 minute for very short content
  return readingTime < 1 ? 1 : readingTime;
}

/**
 * Format the reading time with the appropriate unit (min/mins)
 * @param minutes Reading time in minutes
 * @returns Formatted reading time string
 */
export function formatReadingTime(minutes: number): string {
  return `${minutes} min${minutes !== 1 ? 's' : ''} read`;
}
